import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';

function TestimonialThree() {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);

    return (
        <section className="testi-area3 bg-bottom-center overflow-hidden space" id="testi-sec"
            style={{ backgroundImage: "url(/assets/img/bg/map.png)", backgroundRepeat:"no-repeat" }}>
            <div className="container">
                <div className="title-area text-center">
                    <span className="sub-title">Testimonials</span>
                    <h2 className="sec-title">Our Clients Feedback</h2>
                </div>
                <div className="row justify-content-center">
                    <div className="col-xl-12">
                        {/* Main Swiper */}
                        <Swiper
                            modules={[Pagination, Thumbs]}
                            slidesPerView={1}
                            loop={true}
                            speed={1800}
                            autoplay={{ delay: 3000, disableOnInteraction: false }}
                            pagination={{ clickable: true }}  // Pagination is now explicitly enabled
                            thumbs={{ swiper: thumbsSwiper }} // Link the main Swiper to thumbs swiper
                            className="th-slider testiSlide3 z-index-3"
                        >
                            {testimonials.map((testimonial, index) => (
                                <SwiperSlide key={index}>
                                    <div className="testi-grid">
                                        <div className="testi-grid_author">
                                            <img src={testimonial.image} alt="Avatar" />
                                        </div>
                                        <div className="testi-grid_content">
                                            <p className="testi-grid_text">{testimonial.text}</p>
                                            <h6 className="testi-grid_name box-title">{testimonial.name}</h6>
                                            <span className="testi-grid_desig">{testimonial.designation}</span>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
            {/* Thumbs Swiper */}
            <Swiper
                modules={[Thumbs]}
                slidesPerView={6}
                spaceBetween={7}
                loop={true}
                onSwiper={setThumbsSwiper} // Set thumbsSwiper when this Swiper is initialized
                className="th-slider testi-grid-thumb shape-mockup-wrap"
            >
                {testimonials.map((testimonial, index) => (
                    <SwiperSlide key={index}>
                        <div className="box-img">
                            <img src={testimonial.image} alt="Thumbnail" />
                        </div>
                    </SwiperSlide>

                ))}
                <div className="shape-mockup movingX d-none d-xl-block"
                    style={{
                        top: "0%",
                        left: "5%",
                    }}
                >
                    <img className="gmovingX" src="/assets/img/shape/shape_7.png" alt="shape" />
                </div>
                <div className="shape-mockup spin d-none d-xl-block"
                    style={{
                        bottom: "25%",
                        right: "5%",
                    }}
                >
                    <img src="/assets/img/shape/shape_2_5.png" alt="shape" />
                </div>
                <div className="shape-mockup jump d-none d-xl-block"
                    style={{
                        bottom: "30%",
                        left: "5%",
                    }}
                >
                    <img src="/assets/img/shape/shape_2_2.png" alt="shape" />
                </div>
            </Swiper>
        </section>
    );
}

const testimonials = [
    {
        image: "/assets/img/testimonial/testi_3_1.png",
        text: "Applied for a Russia e-visa through Visto Planet smooth and efficient process. They guided me clearly, resolved my queries, and ensured everything was submitted right the first time. Got approved quickly. Highly recommended!”",
        name: "Aneesh Krishnann",
        designation: "Traveller",
    },
    {
        image: "/assets/img/testimonial/testi_3_2.png",
        text: "“ Got my New Zealand visa through Visto Planet, excellent and professional service! They guided me through every step with timely updates and zero hassles. Highly recommend their reliable visa assistance!”",
        name: "Sibu Sunny",
        designation: "Traveller",
    },
    {
        image: "/assets/img/testimonial/testi_3_3.png",
        text: "“I had a previous US visa rejection, but then I approached Visto Planet and they truly saved the day! Their team is highly professional, transparent, and guided me through every step of the process with clear communication and updates. Thanks to their expertise, I received a 10-year US visa.”",
        name: "Shilpa Sreenivas",
        designation: "Traveller",
    },
    {
        image: "/assets/img/testimonial/testi_3_4.png",
        text: "Visto Planet provided excellent support for my Japan visa process. The team was professional, responsive, and guided me step-by-step. Everything was handled smoothly and on time. Highly recommend their Global Visa services👍🏻!",
        name: "Sugitha Sugunan",
        designation: "Traveller",
    },
    {
        image: "/assets/img/testimonial/testi_3_5.png",
        text: "Got my netherlands visa approved with the help of visto planet and l'm really impressed with their service.they guided me through entire process, ensured all my documents were in order, and kept me updated throughout. Everything was smooth",
        name: "Raneesh Karanath",
        designation: "Traveller",
    },
    
];

export default TestimonialThree;
